/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
     ========================================================================== */

/**
   * Remove the margin in all browsers.
   */

body {
  margin: 0;
}

/**
   * Render the `main` element consistently in IE.
   */

main {
  display: block;
}

/**
   * Correct the font size and margin on `h1` elements within `section` and
   * `article` contexts in Chrome, Firefox, and Safari.
   */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
     ========================================================================== */

/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
     ========================================================================== */

/**
   * Remove the gray background on active links in IE 10.
   */

a {
  background-color: transparent;
}

/**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */

small {
  font-size: 80%;
}

/**
   * Prevent `sub` and `sup` elements from affecting the line height in
   * all browsers.
   */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
     ========================================================================== */

/**
   * Remove the border on images inside links in IE 10.
   */

img {
  border-style: none;
}

/* Forms
     ========================================================================== */

/**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
   * Correct the inability to style clickable types in iOS and Safari.
   */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
   * Remove the inner border and padding in Firefox.
   */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus styles unset by the previous rule.
   */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Correct the padding in Firefox.
   */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from `fieldset` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    `fieldset` elements in all browsers.
   */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

progress {
  vertical-align: baseline;
}

/**
   * Remove the default vertical scrollbar in IE 10+.
   */

textarea {
  overflow: auto;
}

/**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to `inherit` in Safari.
   */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
     ========================================================================== */

/*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */

details {
  display: block;
}

/*
   * Add the correct display in all browsers.
   */

summary {
  display: list-item;
}

/* Misc
     ========================================================================== */

/**
   * Add the correct display in IE 10+.
   */

template {
  display: none;
}

/**
   * Add the correct display in IE 10.
   */

[hidden] {
  display: none;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  vertical-align: baseline;
}


:host {
  display: inline-block;

  --ic-input-label-text-color: var(--ic-switch-label);
  --ic-input-label-helper-text-color: var(--ic-switch-help-text);
  --ic-input-label-helpertext-padding: var(--ic-space-xs);
}

input {
  overflow: hidden;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}

.ic-switch-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
}

.ic-switch-label {
  margin-left: var(--ic-space-xxs);
  margin-bottom: var(--ic-space-xs);
}

.ic-switch-toggle {
  display: flex;
  align-items: center;
  width: calc(var(--ic-space-xl) * 2);
  height: var(--ic-space-xl);
  position: relative;
  border-radius: 100vw;
  background-color: var(--ic-switch-unchecked-bg);
  border: var(--ic-border-width) solid var(--ic-switch-unchecked);
  box-sizing: border-box;
  transition: var(--ic-transition-duration-fast);
  margin-left: var(--ic-space-xxs);
  gap: calc(var(--ic-space-md) + var(--ic-space-xxs));
}

.ic-switch-small .ic-switch-toggle {
  width: var(--ic-space-xxl);
  height: var(--ic-space-lg);
  gap: calc(var(--ic-space-sm) + var(--ic-space-xxxs));
}

.ic-switch-large .ic-switch-toggle {
  width: calc(var(--ic-space-xl) + var(--ic-space-xxl));
  height: calc(var(--ic-space-xl) + var(--ic-space-xs));
  gap: calc(var(--ic-space-lg) + var(--ic-space-xxs));
}

.ic-switch-line-break {
  flex: 1 0 100%;
}

.ic-switch-toggle::before {
  content: "";
  width: calc(var(--ic-space-sm) * 2);
  height: calc(var(--ic-space-sm) * 2);
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: var(--ic-space-xxs);
  transform: translate(0, -50%);
  background-color: var(--ic-switch-unchecked);
  transition: var(--ic-transition-duration-slow);
}

.ic-switch-small .ic-switch-toggle::before {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

.ic-switch-large .ic-switch-toggle::before {
  width: var(--ic-space-xl);
  height: var(--ic-space-xl);
}

.ic-switch-icon {
  display: inline-block;
  vertical-align: middle;
  width: var(--ic-space-sm);
  height: var(--ic-space-sm);
}

.ic-switch-small .ic-switch-icon {
  width: var(--ic-space-xs);
  height: var(--ic-space-xs);
}

.ic-switch-large .ic-switch-icon {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
}

.ic-switch-icon-circle {
  stroke: var(--ic-switch-indicator-off);
  stroke-width: var(--ic-space-1px);
}

.ic-switch-icon-line {
  height: var(--ic-space-sm);
  width: var(--ic-space-1px);
  background-color: var(--ic-switch-indicator-on);
  border-radius: 99px;
  margin-left: calc(
    var(--ic-space-md) + var(--ic-space-xxs) - var(--ic-space-1px)
  );
}

.ic-switch-small .ic-switch-icon-line {
  margin-left: calc(var(--ic-space-md) - var(--ic-space-1px));
  height: var(--ic-space-xs);
}

.ic-switch-large .ic-switch-icon-line {
  margin-left: calc(
    var(--ic-space-xs) + var(--ic-space-md) - var(--ic-space-1px)
  );
  height: var(--ic-space-md);
}

.ic-switch-input:checked + .ic-switch-toggle {
  background-color: var(--ic-switch-checked-bg);
  border: none;
}

.ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(calc(var(--ic-space-xl) - var(--ic-space-1px)), -50%);
  background-color: var(--ic-switch-checked);
}

.ic-switch-small .ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(calc(var(--ic-space-lg) - var(--ic-space-1px)), -50%);
}

.ic-switch-large .ic-switch-input:checked + .ic-switch-toggle::before {
  transform: translate(
    calc(var(--ic-space-xxl) - var(--ic-space-xs) - var(--ic-space-1px)),
    -50%
  );
}

.ic-switch-input:not([disabled]) + .ic-switch-toggle:hover::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-unchecked-bg-hover);
}

.ic-switch-input:not([disabled]) + .ic-switch-toggle:active::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-unchecked-bg-pressed);
}

.ic-switch-input:not([disabled]):checked + .ic-switch-toggle:hover::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-checked-bg-hover);
}

.ic-switch-input:not([disabled]):checked + .ic-switch-toggle:active::before {
  box-shadow: 0 0 0 var(--ic-space-sm) var(--ic-switch-checked-bg-pressed);
}

.ic-switch-input:focus:not([disabled]) + .ic-switch-toggle,
.ic-switch-input:focus-visible:not([disabled]) + .ic-switch-toggle {
  box-shadow: var(--ic-border-focus);
}

.ic-switch-disabled {
  cursor: default;
}

.ic-switch-disabled .ic-switch-icon-circle {
  stroke: var(--ic-switch-indicator-off-disabled);
}

.ic-switch-disabled .ic-switch-icon-line {
  background-color: var(--ic-switch-indicator-on-disabled);
}

.ic-switch-input:disabled + .ic-switch-toggle {
  background-color: var(--ic-switch-unchecked-bg-disabled);
  border: var(--ic-space-1px) dashed var(--ic-switch-unchecked-outline-disabled);
}

.ic-switch-input:disabled + .ic-switch-toggle::before {
  background-color: var(--ic-switch-unchecked-disabled);
}

.ic-switch-input:disabled:checked + .ic-switch-toggle {
  background-color: var(--ic-switch-checked-bg-disabled);
  border: var(--ic-border-width) dashed
    var(--ic-switch-checked-outline-disabled);
}

.ic-switch-input:disabled:checked + .ic-switch-toggle::before {
  background-color: var(--ic-switch-checked);
}

::slotted([slot="right-adornment"]) {
  margin-left: var(--ic-space-sm);
  fill: var(--ic-switch-icon);
}

@media (forced-colors: active) {
  .ic-switch-toggle::before {
    width: calc(var(--ic-space-sm) * 2 - var(--ic-space-xxxs));
    height: calc(var(--ic-space-sm) * 2 - var(--ic-space-xxxs));
  }

  .ic-switch-small .ic-switch-toggle::before {
    width: calc(var(--ic-space-md) - var(--ic-space-xxxs));
    height: calc(var(--ic-space-md) - var(--ic-space-xxxs));
  }

  .ic-switch-large .ic-switch-toggle::before {
    width: calc(var(--ic-space-xl) - var(--ic-space-xxxs));
    height: calc(var(--ic-space-xl) - var(--ic-space-xxxs));
  }

  .ic-switch-toggle::before,
  .ic-switch-input:checked + .ic-switch-toggle {
    border: var(--ic-border-hc);
  }

  .ic-switch-input:focus + .ic-switch-toggle {
    border-color: highlight;
    outline: var(--ic-space-xxxs) solid highlight;
  }

  .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(calc(var(--ic-space-xl) - var(--ic-space-xxxs)), -50%);
  }

  .ic-switch-small .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(calc(var(--ic-space-lg) - var(--ic-space-xxxs)), -50%);
  }

  .ic-switch-large .ic-switch-input:checked + .ic-switch-toggle::before {
    transform: translate(
      calc(var(--ic-space-xxl) - var(--ic-space-xs) - var(--ic-space-xxxs)),
      -50%
    );
  }

  .ic-switch-input:disabled + .ic-switch-toggle,
  .ic-switch-input:disabled:checked + .ic-switch-toggle,
  .ic-switch-input:disabled + .ic-switch-toggle::before {
    border-color: GrayText;
  }

  .ic-switch-icon-line {
    background-color: buttonborder;
  }

  .ic-switch-disabled .ic-switch-icon-circle {
    stroke: GrayText;
  }

  .ic-switch-disabled .ic-switch-icon-line {
    background-color: GrayText;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ic-switch-toggle,
  .ic-switch-toggle::before {
    transition: none;
  }
}
